<template>
  <div>
    <Mainlayout></Mainlayout>

    <CCard class="h-100 col-12 mt-5">
      <br /><br /> <br /><br />
      <CContainer>
      <CCol class="col-12 mt-5 text-center">
        <CCard style="border-radius: 20px" class="box-shadow mt-5">
          <span class="text-center">
            <img
              v-if="studentProfile.ProfileImagePath == null"
              style="border: 1px solid #eee"
              src="../assets/img/default.png"
              class="grey lighten-2 rounded-img img-profile mt-2"
            />

            <img
              v-else
              style="border: 3px solid #ddd; background: #fff"
              :src="photoURL"
              class="grey lighten-2 rounded-img img-profile mt-2"
            />
          </span>
          <br />

          <span class="text-center custom-font">
            <strong> {{ studentProfile.StudentName }} </strong>
          </span>

          <div class="text-center custom-font mb-2">
            {{ studentProfile.Email }}
          </div>
          <div class="text-center mb-4 mt-2">
            <span @click="GotoPageStudent">
              <CButton
                style="width: 30%"
                class="bg-gradient-turqouise text-white"
              >
                View
              </CButton>
            </span>
          </div>
        </CCard>
        <CCard>
          <CRow>
            <CCol class="col-12">
              <CRow>
                <CCol class="col-8 text-left mt-2">
                  <span class="custom-font ml-3"> List Of Subject </span>
                </CCol>
                <CCol class="col-4 text-right">
                  <span @click="GotoPageGrade">
                    <CIcon name="cil-pencil" class="mr-3 mt-2" />
                  </span>
                </CCol>
              </CRow>
            </CCol>
            <CCol class="col-12">
              <br />
              <span
                v-for="item in studentProfile.StudentSubjectJson"
                v-bind:key="item.SubjectID"
                class="text-left"
              >
                <CCol sm="12" lg="12">
                  <CRow>
                    <div class="col-6">
                      <h6 class="mb-0 custom-font custom-gradient">
                        {{ item.SubjectName }}
                      </h6>
                      <span class="small text-muted">
                        <strong>Grade : {{ item.Grade }}</strong>
                      </span>
                    </div>
                    <div class="col-6 text-right">
                      <br />
                      <span class="small text-muted text-right custom-font">
                        <strong>{{ item.ClassName }} </strong></span
                      >
                    </div>
                  </CRow>
                </CCol>
                <hr
                  style="
                    margin-top: 5px;
                    margin-bottom: 5px;
                    border: 1px dashed #ddd;
                  "
                />
              </span>
            </CCol>
          </CRow>
        </CCard>
      </CCol>
      </CContainer>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      studentProfile: {},

      photoURL: "",
      //   quizList: [],
      //   SubmittedForm: false,
      //   Error: false,
      //   hasScrolledToBottom: false
    };
  },
  async mounted() {
    this.GetUserProfile();
  },
  methods: {
    GotoPageStudent() {
      this.$router.push("/QuizStudent?userId=" + this.$route.query.userId);
    },
    GotoPageGrade() {
      this.$router.push(
        "/QuizGrade?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    async GetUserProfile() {
      this.$API
        .get(
          this.$StudentProfile + "?studentId=" + this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfile = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfile.ProfileImagePath;
            $("#profileImage").text(this.photoURL);
          }
        });
    },
  },
};
</script>